export default theme => ({
  container: { flex: "1" }
});
